import { Movement } from '../types'

export interface StockMovementsState {
  filters: MovementsFilters
  movements: Movement[]
  totalItems: number
  loading: boolean
  badge?: string
  batchAndStockBatchDueList?: BatchAndStockBatchDue[]
  selectedBatchAndStockBatchDue?: BatchAndStockBatchDue
  inputAddress?: ValidatedAddress
  batchInfo?: BatchInfo
  batchesList: BatchItem[]
  fromAddress?: ValidatedAddress
  toAddress?: ValidatedAddress
  items?: PkItem[]
  validatedAddress?: boolean
  pkModalDisableButtons: boolean
}

enum Type {
  RECEIVEMENT,
  DAMAGED,
  ADJUSTMENT,
  CHECKOUT,
  REFUND
}

export interface MovementsFilters {
  page: number
  fulfillmentCenterId?: number
  modelId?: number
  type?: Type
  sourceSystem?: string
  startDate?: Date
  endDate?: Date
  description?: string
  code?: string,
  user?: string,
}

export interface ReplacementState {
  loading: boolean
  badge?: string
  batches?: Batch[]
  selectedBatch?: Batch
  inputAddress?: ValidatedAddress
  batchInfo?: BatchInfo
  batchesList: BatchItem[]
}

export interface ReplacementSchemaType {
  badge: string
  batch: string
  quantity: number | string
  withdrawAddress: string
  inputAddress: string
}

export interface ValidateSupervisorBadgeParams {
  badge: string
  setError: (error: string) => void
  onSuccess: () => void
}

export interface GetBatchParams {
  batchOrProductCode: string
  address: string
  badge: string
  setError: (error: string) => void
  onSuccess: () => void
}
export interface GetAddressApiParams {
  address: string
  fcId: string
}

export type GetAddressSagaParams = {
  setError: (error: string) => void
  onSuccess: (value: string | undefined) => void
} & GetAddressApiParams

export interface MoveBatchApiParams {
  addressId: number
  qty: number
  lotStockId: number
  userBadge: string
}

export type MoveBatchSagaParams = {
  onSuccess: () => void
  setDisabledConfirmButton: (disabled: boolean) => void
} & MoveBatchApiParams

export interface Address {
  capacidadeCm3: number
  enderecoGenerated: string
  escaninhoNivel: string
  fulfillmentCenterId: number
  galpao: string
  idLocalizacao: number
  isGondola: boolean
  posicaoPallete: string
  rua: string
}

export interface AddressTag {
  rua: string
}

export interface Fc {
  name: string
}

export interface MeasureUnit {
  isKg: boolean
}

export interface Batch {
  address: Address
  addressDetail?: any
  addressTag: AddressTag
  codProduto: string
  codigoDeBarrasUtilizado?: any
  dataFimFracionamento?: any
  dataInclusao: Date
  dataInicioFracionamento?: any
  dataValidade: string
  descricao: string
  descricaoPersonalizada?: any
  diretoGondola: boolean
  dtCancelado?: any
  fc: Fc
  idLocalizacaoDestino: number
  idLote: number
  idModelo: number
  idModelo_verificado: boolean
  idRecebimento: number
  idStatuslote: number
  idUnidademedidarecebimento: number
  idUsrCancelado?: any
  measureUnit: MeasureUnit
  observacao?: any
  quantidadeAvaria: number
  quantidadeRejeitada?: any
  quantidadeTotal: number
  quantidadeTotal_original?: any
  quantidadeUtil?: any
  temperaturaItem?: any
  tipoAvaria: string,
  batchNumber: number,
}

export interface BatchAndStockBatchDue {
  batch: Batch
  stockBatchDue: StockBatchDue
}

export interface StockBatchDue {
  dataValidade: string
  dtAuditAlteracao: Date
  dtAuditInclusao: Date
  idEstoque: number
  idEstoqueValidade: number
  idLoteRecebimento: number
  idModelo: number
  quantidade: number
}

export interface ValidatedAddress {
  idLocalizacao: number
  message: string
  statusCode: string
}

export interface ReplacementDetailProps {
  description: string
  expirationDate: Date
  quantity: number
  movementedQuantity?: number
}

export interface BatchInfoAddress {
  idStockBatchDue: number
  idAddress: number
  fc: number
  warehouse: string
  street: string
  shelf: string
  bin: string
  addressFormated: string
  quantity: number
  dueDate: string
}

export interface BatchInfo {
  idBatch: number
  idModel: number
  productDescription: string
  productCode: string
  addresses: BatchInfoAddress[]
}

export interface GetBatchInfoApiParams {
  batchId: string
  fcId: string
  badge: string
}

export type GetBatchInfoSagaParams = {
  setError: (error: string) => void
  onSuccess: () => void
} & GetBatchInfoApiParams

export interface BatchItem {
  batchId: number
  validity: string
  quantity: number
  address: string
  idStockBatchDue: number
  productDescription: string
}

export interface Movimentation {
  idStockBatchDue: number
  quantity: number
}

export interface PostMovimentationApiParams {
  idAddress: number
  movimentations: Movimentation[]
  badge: string
}

export type PostMovimentationSagaParams = {
  onSuccess: () => void
  onError: () => void
} & PostMovimentationApiParams

export enum GenericApiErrors {
  Failed
}

export interface BatchAndStockBatchDuePartial {
  batch: Partial<BatchAndStockBatchDue['batch']>
  stockBatchDue: Partial<BatchAndStockBatchDue['stockBatchDue']>
}

export interface MovementErrorStatus {
  id: number
  message: string
}

interface MovementStatus {
  success: number[]
  error: MovementErrorStatus[]
}

export interface BatchesMovement {
  status: MovementStatus
}

export interface UpdateMovementsField {
  key: keyof StockMovementsState;
  value: StockMovementsState[keyof StockMovementsState];
}

export interface PkMovementSchemaType {
  badge: string
  barcode: string
  withdrawAddress: string
  inputAddress: string
}

export interface GetPkItemsApiParams {
  address: string
  fcId: string
  badge: string
}

export type GetPkItemsSagaParams = {
  setError: (error: string) => void
  onSuccess: () => void
} & GetPkItemsApiParams

export interface ValidatePkModelBarcodeApiParams {
  barcode: string
  item: PkItem
}

export type ValidatePkModelBarcodeSagaParams = {
  setError: (error: string) => void
  onSuccess: () => void
} & ValidatePkModelBarcodeApiParams

export interface ValidateMovementAddressApiParams {
  idModel: number
  address: string
  addressToValidate: string
  isGondola: boolean
}

export type ValidateMovementAddressSagaParams = {
  setError: (error: string) => void
  onSuccess: () => void
} & ValidateMovementAddressApiParams

export interface PkItemMovementApiParams {
  item: PkItem
  startedAt: Date
  badge: string
}

export type PkItemMovementSagaParams = {
  onSuccess: () => void
} & PkItemMovementApiParams

export interface PkItemDidNotFitsApiParams {
  items: PkItem[]
  item: PkItem
  startedAt: Date
  badge: string
}

export type PkItemDidNotFitsSagaParams = {
  onSuccess: () => void
} & PkItemDidNotFitsApiParams

export interface PkBatch {
  idBatchReceivement: number
  idBatchStockExpiration: number
  batchNumber: number
  expirationDate: string
  quantity: number
}

export interface PkLocation {
  id: number
  address: string
}

export interface PkItem {
  idModel: number
  productDescription: string
  batches: PkBatch[]
  volume: number
  productVolume: number
  isPallet: boolean
  isGondola: boolean
  order: number
  bestPosition: PkLocation
  gondolaAddress: PkLocation
  isInternal: boolean
  done?: boolean
}

export interface CheckStockAtAddressParams {
  address: string
}
